import Styles from './HeroSequence.module.css'

import type {ThemedUrls} from '../../../../Index.types'
import {BackgroundGrid} from '../../BackgroundGrid/BackgroundGrid'

export interface HeroSequenceProps {
  currentChapterIndex: number
  chaptersAltDesc: string[]
  video?: {
    url: ThemedUrls
    chapterTimestamps: number[]
  }
  onNextChapter: (chapterIndex: number) => void
  onReady: (chapterDurations: number[]) => void
}

export const defaultProps: Partial<HeroSequenceProps> = {}

export const HeroSequence = (props: HeroSequenceProps) => {
  const initializedProps: HeroSequenceProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return (
    <div className={Styles['HeroSequence']}>
      <BackgroundGrid hasCornerDots />
    </div>
  )
}
